import React from "react";
import { IReportContext } from "./ReprortContextTypes";

export const reportContext = React.createContext<IReportContext>({});

export const useReportContext = () => React.useContext(reportContext);

export default reportContext;
